var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDownloadBro(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path--inject-15"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M284.61,219s-1.65,5.91-1,8,3.17,4.54,2.66,7-3.27,5.42-3,7.36,3.52,2.88,3.52,2.88,4.63,8.92,6,12,2.35,2.2,5.41,2,10.37-4.34,14.73-7.76,1.09-17.24-4.76-27.26S290.77,211,287.79,212.94,284.61,219,284.61,219Z",
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-2--inject-15"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M306.17,256.36s4.4,1.35,3.73,5.08-1.36,7.11-1.36,7.11,24,.68,23.71-.68-7.11-24.38-7.11-24.38S312.27,242.81,306.17,256.36Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-3--inject-15"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M283.82,272.61c-7,4.43-4.93,9.26-3.24,17.65,3.82,18.91,8.94,55.45,7,64.65-2.28,10.76-8.69,17.62-17.5,17.62-4.09,0-5.05,3.93-9.48,2-9.48-4.07-16.62-1.1-20,1.69-13.89,11.52,3.66,52.2,24,62,18.2,8.73,37.71,3,47.32-.89,3.44-1.4,7.09-.74,10.69.18,18.88,4.77,34.12-11.48,35.81-26,2.6-22.36-4.4-23.37-7.92-48.09a60.19,60.19,0,0,1-.33-8.13c-.11-17.1,6.78-33,5.07-58.93-.68-10.23-2.29-23.35-9.14-27.09C317.4,253.55,284.05,272.47,283.82,272.61Z",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-4--inject-15"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M248.33,352.65s-7.07-4.53-8.94-4.35-4.35,1.6-5,1.66-2.39-.24-3.5.57a12,12,0,0,0-2.13,2.36,28.93,28.93,0,0,0-3.35,2.21c-1.76,1.35-5.69,7.17-6.28,8.42s.18,1.87,1.28,1.06c.81-.61,4.19-3.78,5.91-5.4a2.2,2.2,0,0,1,2.32-.45c1.89.74,5.27,2.13,6.36,3.06a12.8,12.8,0,0,0,6.71,3.1,37.43,37.43,0,0,0,7.1,0s3.84-4.86,2.77-8.07A6.7,6.7,0,0,0,248.33,352.65Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-5--inject-15"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M299,292.71c-.45-6.81-6.75-20.07-13.48-21.2a31.59,31.59,0,0,0-4.41,2.94c-2.56,2.05-3.33,6.14-3.56,14.76s1.36,28.45.34,46.74c0,.34-25.51,14.11-29.93,16.25s-7.28,6.17-4.77,10.4c2.23,3.75,7,2.94,11.33,2.36,5.81-.77,33-6.45,37.94-11.51C302.24,343.29,299,292.71,299,292.71Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-6--inject-15"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M249.83,351.36s.1,1-4-1.7c-3.9-2.54-14.06,6.78-10.15,13.14l.33,1.09c.44,1.48,3.28.52,4.74,1a11.37,11.37,0,0,0,5.59.5C249.4,365.07,240.94,360,249.83,351.36Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-simple--inject-15"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M450.92,247.75C407.08,149.38,256.31,66,165.42,78.8c-39.54,5.58-94.1,41.71-119.77,112.28C28.78,237.48-29.2,410.29,232.78,400.66S450.92,247.75,450.92,247.75Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.78,400.66c-262,9.63-204-163.18-187.13-209.58C71.32,120.5,125.88,84.38,165.42,78.8c32.37-4.57,72.33,3.07,112.36,19.24a379.79,379.79,0,0,1,41,19.56c57.35,31.63,109.28,78.86,132.14,130.15C450.92,247.75,494.76,391,232.78,400.66Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-15"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 255.84,
    cy: 425.87,
    rx: 160.54,
    ry: 21.85,
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 255.84,
    cy: 425.87,
    rx: 160.54,
    ry: 21.85,
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-15"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M98.92,360.05c-.09.15.69.88-1.87,1-6.32.28-17.49-.11-21.7-5.84-6-8.18,7.8-7.47,6.45-12s-16.18-.78-19.1-7.22,7.88-5.22,7.37-8.54-11.82,1-15.57-5.82,6.15-3.2,4.54-6-14.2-14.6-9.12-17.25,16.91,9.65,20.8,11,4.76-10.79,9.89-6.76,1.82,22.29,7.79,24.54c4.45,1.67,2-4.86,7.49-4.62C103.33,322.79,105.86,348.37,98.92,360.05Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M98.92,360.05c-.09.15.69.88-1.87,1-6.32.28-17.49-.11-21.7-5.84-6-8.18,7.8-7.47,6.45-12s-16.18-.78-19.1-7.22,7.88-5.22,7.37-8.54-11.82,1-15.57-5.82,6.15-3.2,4.54-6-14.2-14.6-9.12-17.25,16.91,9.65,20.8,11,4.76-10.79,9.89-6.76,1.82,22.29,7.79,24.54c4.45,1.67,2-4.86,7.49-4.62C103.33,322.79,105.86,348.37,98.92,360.05Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M117.53,361.08c5.09,1.05,14.69-2.08,19-6.06s-6-2.94-4.28-6.43,13.23,1.46,16.43-3.39-5.71-5.26-4.87-7.89,9.75-.41,13.68-5.47-4.57-3.39-2.9-5.48,13.42-10,9.64-12.82-15,5.64-18.31,6.19-2.75-6.6-7.43-4-4.37,17.85-9.51,18.9c-3.83.78-1.07-5.66-5.48-4.72C115.75,331.56,115.46,360.66,117.53,361.08Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.23,322.29s-30.11,20.25-38.5,57.31",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.7,334a27.13,27.13,0,0,0-11.07.15h0",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.6,319a35.81,35.81,0,0,0-8.43,19.24",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.34,343.82a11.49,11.49,0,0,1,11-.67",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.78,353.33A27.31,27.31,0,0,1,122,339.4",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.23,358.29c6.09-1.68,14.78-10.36,17.23-17s-8.1.1-8.19-4.61,15.15-5.72,16-12.74-9.1-2.55-9.63-5.87,10.34-5.82,11.81-13.47-6.83-1.16-6.17-4.35,9-18.26,3.39-19.22-13.13,14.38-16.44,16.82-6.63-5.65-10.27-.24,5.11,21.78.12,25.75c-3.72,3-4.28-5.55-8.55-2.1C91,327.25,106.75,359,109.23,358.29Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M109.23,358.29c6.09-1.68,14.78-10.36,17.23-17s-8.1.1-8.19-4.61,15.15-5.72,16-12.74-9.1-2.55-9.63-5.87,10.34-5.82,11.81-13.47-6.83-1.16-6.17-4.35,9-18.26,3.39-19.22-13.13,14.38-16.44,16.82-6.63-5.65-10.27-.24,5.11,21.78.12,25.75c-3.72,3-4.28-5.55-8.55-2.1C91,327.25,106.75,359,109.23,358.29Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M113.82,430.93c-.34.08-11.86.08-12.19,0-8.46-1.85-38.47-11.71-11.42-43.65h34.63C151.88,419.2,122.27,429.08,113.82,430.93Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.83,322.52S98.35,339.26,103.7,382",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.09,327.75c5.92-1.27,9.54-.1,9.54-.1",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.8,310.11s7.44,9.84,7.36,22.68",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.46,343.62s-5.3-5-12.33-2.43",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.29,351.19a30.75,30.75,0,0,0,1.25-15.69",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.47,303.11S103,331.77,109.75,383.93",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.45,307.2c-10.73,0-16.39,4.12-16.73,4.38h0",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.4,319.55a49.13,49.13,0,0,1-1.8-22.07",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.07,335.36s4.26-8.1,13.45-8.18",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.54,345.83s-5.74-6.4-7.53-17.75",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "89.47 387.29 125.86 387.29 128.07 376.98 87.27 376.98 89.47 387.29",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.06,400.1a23,23,0,0,1,2.09,11.55c-.23,2.82-1.27,5.94-3.85,7.11",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124,394a22.45,22.45,0,0,1,2.43,3.07",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Device--inject-15"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--freepik--Device--inject-2--inject-15"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "247.52 315.58 176.12 315.58 189.29 369.28 260.7 369.28 247.52 315.58",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "244.14 318.69 181.02 318.69 192.68 366.16 255.79 366.16 244.14 318.69",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "244.14 318.69 181.02 318.69 182.12 323.13 245.23 323.13 244.14 318.69",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 188.16,
    y: 364.48,
    width: 104.53,
    height: 4.8,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 235.48,
    y: 364.48,
    width: 57.23,
    height: 4.8,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "236.91 340.71 237.63 343.72 190.4 343.72 189.68 340.71 236.91 340.71",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.77,345.2H190.38l-1.42-6h57.39Zm-56.83-.69h56l-1.1-4.65h-56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "220.68 336.47 213.7 336.47 211.96 329.49 213.95 329.49 214.1 330.08 212.7 330.08 214.14 335.88 219.94 335.88 218.49 330.08 217.06 330.08 216.91 329.49 218.94 329.49 220.68 336.47",
    style: {
      fill: "#92E3A9",
      stroke: "#92E3A9",
      strokeMiterlimit: 10,
      strokeWidth: "0.2px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "216.62 332.98 216.03 332.98 214.37 326.31 214.96 326.31 216.62 332.98",
    style: {
      fill: "#92E3A9",
      stroke: "#92E3A9",
      strokeMiterlimit: 10,
      strokeWidth: "0.2px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "216.42 333.32 213.92 332.17 214.06 331.65 216.23 332.64 217.81 331.54 218.24 332.05 216.42 333.32",
    style: {
      fill: "#92E3A9",
      stroke: "#92E3A9",
      strokeMiterlimit: 10,
      strokeWidth: "0.2px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Desk--inject-15"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "364.71 163.81 333.98 247.36 338.38 247.36 368.41 165.72 364.71 163.81",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.58,149.46l-56-61.94a4.34,4.34,0,0,1-.06.62,4.85,4.85,0,0,1-1.38,2.53,23.15,23.15,0,0,1,6.13,7.88l46.08,51,.59-4.9Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.4,88.17h0l.56.34L312.17,90l-.29.53.22.17a4.85,4.85,0,0,0,1.38-2.53,4.34,4.34,0,0,0,.06-.62,4.85,4.85,0,0,0-9.6-1.31l.62.28A23.18,23.18,0,0,1,308.4,88.17Z",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "327.92 247.36 327.92 271.19 342.01 271.19 342.01 262.85 330.98 262.85 330.98 255.05 342.01 255.05 342.01 247.36 338.38 247.36 333.98 247.36 327.92 247.36",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.56,86.49l-.62-.28-.05.06Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309,88.52a24.43,24.43,0,0,1,2.88,2l.29-.53Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "368.76 165.9 374.41 154.45 369.58 149.46 364.9 144.62 364.31 149.52 362.73 162.79 364.71 163.81 368.41 165.72 368.76 165.9",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.4,110.43a10.92,10.92,0,0,0,19.2,1.24q-9.74-5-19.58-9.31A10.93,10.93,0,0,0,288.4,110.43Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.1,90.67l-.22-.17a24.43,24.43,0,0,0-2.88-2l-.56-.34h0a23.18,23.18,0,0,0-3.84-1.68l-.67-.22A23.37,23.37,0,0,0,276.67,97.4s0,0,0,0l1.12.62q5.13,2.07,10.24,4.32,9.83,4.33,19.58,9.31,5.61,2.86,11.18,5.93a23.47,23.47,0,0,0-6.68-26.93Z",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 328.66,
    y: 256.02,
    width: 114.81,
    height: 152.41,
    style: {
      fill: "#bfbfbf",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 341.86,
    y: 269.23,
    width: 86.36,
    height: 29.47,
    style: {
      fill: "#757575",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 341.86,
    y: 307.84,
    width: 86.36,
    height: 85.35,
    style: {
      fill: "#757575",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 320.53,
    y: 246.81,
    width: 130.38,
    height: 9.14,
    style: {
      fill: "#757575",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.94,276.68a3.73,3.73,0,1,1-3.72-3.73A3.72,3.72,0,0,1,388.94,276.68Z",
    style: {
      fill: "#bfbfbf",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 418.41,
    cy: 349.22,
    rx: 5.76,
    ry: 12.53,
    style: {
      fill: "#bfbfbf",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.41,367.78h0a3,3,0,0,1-3.05-3V334.93a3,3,0,0,1,3.05-3.05h0a3,3,0,0,1,3,3.05v29.81A3,3,0,0,1,418.41,367.78Z",
    style: {
      fill: "#bfbfbf",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "430.11 235.99 438.67 213.72 437.35 213.72 428.19 235.99 430.11 235.99",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "392.78 235.93 384.22 213.66 385.54 213.66 394.69 235.93 392.78 235.93",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "393.13 235.93 393.56 236.93 394.84 236.93 394.43 235.93 393.13 235.93",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "429.79 235.93 429.35 236.93 428.07 236.93 428.48 235.93 429.79 235.93",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 390.92,
    y: 242.75,
    width: 5.3,
    height: 3.3,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 426.84,
    y: 242.75,
    width: 5.3,
    height: 3.3,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434,244.21l-11.5,1.25a102,102,0,0,1-22,0L389,244.21v-7.14l9.35-1.21a102.29,102.29,0,0,1,26.28,0l9.34,1.21Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.7,240.85a2.14,2.14,0,1,1-2.13-2.13A2.14,2.14,0,0,1,395.7,240.85Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.63,240.86a.68.68,0,1,1-.67-.67A.67.67,0,0,1,405.63,240.86Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.43,240.86a.67.67,0,1,1-.67-.67A.67.67,0,0,1,410.43,240.86Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.24,240.86a.68.68,0,1,1-.68-.67A.67.67,0,0,1,415.24,240.86Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420,240.86a.67.67,0,0,1-.67.68.68.68,0,1,1,0-1.35A.67.67,0,0,1,420,240.86Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.91,246.36h3.86a1.11,1.11,0,0,1-.18-.38A33.73,33.73,0,0,1,365.91,246.36Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.91,246.36h3.86a1.11,1.11,0,0,1-.18-.38A33.73,33.73,0,0,1,365.91,246.36Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.72,244.27c0,.13.24.14.33.26.37.45-.15,1.53-.3,1.83H377l-4-6.89C372.44,241.47,371.4,243.27,371.72,244.27Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.72,244.27c0,.13.24.14.33.26.37.45-.15,1.53-.3,1.83H377l-4-6.89C372.44,241.47,371.4,243.27,371.72,244.27Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.05,244.53c-.09-.12-.29-.13-.33-.26-.32-1,.72-2.8,1.25-4.8q.11-.41.18-.81c.41-2.32-.2-4.47.56-5.6.3-.45.89-.68,1-1.21s-.42-.77-.56-1.22c-.35-1.13,1-3.28,1.43-5.6s-.19-4.48.56-5.61c.09-.13.29-.14.43-.25.62-.53.34-1.91.34-1.91s-1.29-.53-1.91,0c-.16.13-.21.36-.38.44-1.58.79-4.55-.51-8-.51s-6.89,1.28-8.2.49c-.14-.08-.11-.32-.21-.45-.44-.52-1.91,0-1.91,0s-.77,1.38-.34,1.91c.09.11.29.12.33.26.36,1.13-1,3.28-1.43,5.6s.2,4.47-.56,5.6c-.3.45-.89.68-1,1.22s.42.76.56,1.21c.36,1.13-1,3.28-1.43,5.6s.2,4.48-.56,5.61c-.09.13-.29.14-.43.26-.62.52-.34,1.9-.34,1.9s1.29.53,1.91,0a1.74,1.74,0,0,0,.38-.44,49.68,49.68,0,0,0,8,.51c1.63,0,3.17,0,4.52-.11a33.73,33.73,0,0,0,3.68-.38,1.11,1.11,0,0,0,.18.38s0,0,0,.07c.43.53,1.9,0,1.9,0l0-.07C371.9,246.06,372.42,245,372.05,244.53ZM362,243.47h0a6.29,6.29,0,0,1-6.33-7.7l1.33-7.45a9.57,9.57,0,0,1,9.05-7.68,6.29,6.29,0,0,1,6.33,7.71L371,235.79A9.56,9.56,0,0,1,362,243.47Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371,235.79l1.33-7.44a6.29,6.29,0,0,0-6.33-7.71,9.57,9.57,0,0,0-9.05,7.68l-1.33,7.45a6.29,6.29,0,0,0,6.33,7.7h0A9.56,9.56,0,0,0,371,235.79Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Download--inject-15"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M224.77,118.75A23.15,23.15,0,0,1,203,141.86c-.47,0-62.11,0-62.7,0A23.16,23.16,0,0,1,140,95.69a33.13,33.13,0,0,1,66.18.36A23.16,23.16,0,0,1,224.77,118.75Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.35,86.4a29.6,29.6,0,0,1,27.28-18.1",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.08,96.23a28.62,28.62,0,0,1,.73-5.1",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173,254.76c1.53,3.46,3.08,6.85,4.67,10.14",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.91,156.66s12,47,29.1,88.72",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.28,191.65c.08,1.8.07,3.13.18,4.74",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.28,148.44c-.09.85-.74,21.76-.26,38.62",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.28,287.13,215,319.58l-40.78-30.15,20.32-.75-1.3-3.17a685.11,685.11,0,0,1-41.85-146l-4.08-24,50.07-.52-.24,7.57a684.65,684.65,0,0,0,20,165.3Z",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.64,116.89h18.6l.06,6.55a358.13,358.13,0,0,0,2.37,38.18h0l-28,1.4-1.45-8.31a163.45,163.45,0,0,1-2.42-24.47h0l10.9-13.32",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "170.85 129.97 158.86 130.14 169.65 116.92 170.85 129.97",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.76,304.21a11.83,11.83,0,0,1-4.1-.77,6.71,6.71,0,0,1-3.66-4.28c-.06-.21-.11-.42-.15-.64a9.64,9.64,0,0,1,.45-4.77c1-3,3.33-4.58,6.83-4.58a14.94,14.94,0,0,1,3.67.5l.18,0-10.92-31.08a1,1,0,0,1,.11-.86.91.91,0,0,1,.69-.36h0a1.28,1.28,0,0,1,1.2.81l.27.76a11.42,11.42,0,0,0,6.27,3.74A12.73,12.73,0,0,1,207.8,266a8.13,8.13,0,0,1,2.26,3.5l2.8,7.94a.84.84,0,0,1,0,.66.77.77,0,0,1-.47.39l-.12,0-.2,0a1.13,1.13,0,0,1-.7-.31,11.62,11.62,0,0,0-6.65-4.21,10.3,10.3,0,0,1-4.43-2.13l7.3,20.8a11.08,11.08,0,0,1-.28,8A7.13,7.13,0,0,1,200.76,304.21Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.92,257.91a.78.78,0,0,1,.68.49l.3.84a11.93,11.93,0,0,0,6.61,4,12.18,12.18,0,0,1,5.94,3.13,7.57,7.57,0,0,1,2.13,3.28l2.81,8a.3.3,0,0,1-.18.4l-.1,0h0a.65.65,0,0,1-.42-.19,12.11,12.11,0,0,0-6.89-4.33,11.18,11.18,0,0,1-5.63-3.27l7.93,22.59a10.78,10.78,0,0,1-.24,7.57,6.64,6.64,0,0,1-6.08,3.36,11.34,11.34,0,0,1-3.91-.73,6.21,6.21,0,0,1-3.37-3.94,5.43,5.43,0,0,1-.13-.58,9,9,0,0,1,.43-4.55c1.08-3.36,3.81-4.23,6.35-4.23a14.85,14.85,0,0,1,3.54.48c.21,0,.39.1.56.14l.12,0,.43.14-11.25-32c-.08-.3.06-.55.36-.56h0m0-1h-.08a1.37,1.37,0,0,0-1.07.57,1.45,1.45,0,0,0-.2,1.27v.05L203.21,289a15.28,15.28,0,0,0-3.08-.34c-3.74,0-6.26,1.7-7.31,4.92a10.26,10.26,0,0,0-.46,5,6.24,6.24,0,0,0,.15.67,7.17,7.17,0,0,0,4,4.62,12.32,12.32,0,0,0,4.28.8,7.59,7.59,0,0,0,6.94-3.86,11.67,11.67,0,0,0,.33-8.39l-6.8-19.35a10,10,0,0,0,3.35,1.33,11,11,0,0,1,6.31,4l0,.06,0,.05a1.64,1.64,0,0,0,1,.45h0l.25,0,.25-.07a1.32,1.32,0,0,0,.77-.64,1.34,1.34,0,0,0,.06-1l-2.81-8a8.56,8.56,0,0,0-2.39-3.68,13.18,13.18,0,0,0-6.43-3.38,11,11,0,0,1-5.92-3.5l-.23-.66a1.79,1.79,0,0,0-1.63-1.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.25,222.08l27.14-5.85q-5.05-22.08-8.07-44.55l-30.09,6.49Q146.73,200.37,153.25,222.08Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.38,206.83l-22,4.75c-2.56-9.45-3.72-14.2-5.8-23.76l23.31-5C172.42,192.46,173.33,197.27,175.38,206.83Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166,196.05c-1.67,5.48-2.47,8.22-4,13.67l13.38-2.88C171.53,202.54,169.65,200.38,166,196.05Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158,194.84c-2,6.72-2.9,10.07-4.68,16.74l16.34-3.52C164.91,202.79,162.58,200.15,158,194.84Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.2,189.48a2.47,2.47,0,0,1-1.8,2.9,2.31,2.31,0,0,1-2.7-1.92,2.48,2.48,0,0,1,1.8-2.93A2.3,2.3,0,0,1,170.2,189.48Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.66,250.64,222.49,253a115.45,115.45,0,0,1-6.15-44.28l-30.05-7.25A127.3,127.3,0,0,0,191.66,250.64Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214,230.54c.92,6.71-3.17,11.45-9.92,10.68S190.55,234,189.73,226.7s4.61-12.12,11.26-10.78S213.13,223.84,214,230.54Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.93,229.74c-4.88-3.38-7.27-5.12-12-8.71a102.44,102.44,0,0,0,1.66,13.81C202.69,232.7,204.75,231.68,208.93,229.74Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-15"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M206,370.32c15.69-7.44,74.76,12,74.76,12L277,390.52S185.74,379.93,206,370.32Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.91,391.25A133.36,133.36,0,0,1,261.69,385c-15.8-7.76-46.81-21.32-58.11-14.38-15.45,9.47-5.15,35.65,29.77,52.94s60.88,17.55,69.21,9.45C310.16,425.66,296.26,397.94,276.91,391.25Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--group--inject-15"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M284.61,219s-1.65,5.91-1,8,3.17,4.54,2.66,7-3.27,5.42-3,7.36,3.52,2.88,3.52,2.88,4.63,8.92,6,12,2.35,2.2,5.41,2,10.37-4.34,14.73-7.76,1.09-17.24-4.76-27.26S290.77,211,287.79,212.94,284.61,219,284.61,219Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path--inject-15)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M302.19,216.58c-1.91,4.48-4.51,12.31-2.75,18.34,2.65,9.06,5.13,14,1.36,20.27-.68,1.08-1.34,2.06-2,2.91,3.35-.69,10-4.47,14-7.65,4.35-3.42,1.09-17.24-4.76-27.26A22.28,22.28,0,0,0,302.19,216.58Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.19,216.58c-1.91,4.48-4.51,12.31-2.75,18.34,2.65,9.06,5.13,14,1.36,20.27-.68,1.08-1.34,2.06-2,2.91,3.35-.69,10-4.47,14-7.65,4.35-3.42,1.09-17.24-4.76-27.26A22.28,22.28,0,0,0,302.19,216.58Z",
    style: {
      fill: "#fff",
      opacity: 0.5,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.34,228.85s.63-3.11,3.94-.28",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290,234.13c.32,1.06.18,2-.33,2.19s-1.16-.58-1.48-1.64-.18-2,.31-2.17S289.7,233.08,290,234.13Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M284.61,219s-1.65,5.91-1,8,3.17,4.54,2.66,7-3.27,5.42-3,7.36,3.52,2.88,3.52,2.88,4.63,8.92,6,12,2.35,2.2,5.41,2,10.37-4.34,14.73-7.76,1.09-17.24-4.76-27.26S290.77,211,287.79,212.94,284.61,219,284.61,219Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M286.76,353.36s-6.15-5.71-8-5.87-4.57.81-5.27.75-2.31-.67-3.54-.06a11.84,11.84,0,0,0-2.52,1.94,29.12,29.12,0,0,0-3.68,1.58c-2,1-6.88,6.05-7.68,7.17s-.16,1.88,1.07,1.27,7.93-5,7.93-5,5.64,3.3,6.93,4.87a12.74,12.74,0,0,0,6,4.23,37.59,37.59,0,0,0,7,1.29s4.63-4.1,4.16-7.46A6.76,6.76,0,0,0,286.76,353.36Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.6,275.22a30.58,30.58,0,0,0-4.64,2.57c-2.72,1.83-5.4,5.81-6.33,14.38s-.83,28.89-.93,37.52c-.23,20-26.49,19.81-31.07,21.58s-8.88,6.81-6.73,11.23c1.91,3.93,7.25,4.32,11.61,4.11,5.85-.29,36-1.9,40.44-5.46,6.46-5.18,5-12.35,5.81-20.6,2.59-25,2.93-50.83,2.93-50.83a14.7,14.7,0,0,0-11.09-14.5Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.17,256.36s4.4,1.35,3.73,5.08-1.36,7.11-1.36,7.11,24,.68,23.71-.68-7.11-24.38-7.11-24.38S312.27,242.81,306.17,256.36Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-2--inject-15)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M327.59,253.63l-17.69,7.81-.31,1.82s14.8-2,19.07-6.06l-1.07-3.57",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.59,253.63l-17.69,7.81-.31,1.82s14.8-2,19.07-6.06l-1.07-3.57",
    style: {
      fill: "#fff",
      opacity: 0.5,
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M306.17,256.36s4.4,1.35,3.73,5.08-1.36,7.11-1.36,7.11,24,.68,23.71-.68-7.11-24.38-7.11-24.38S312.27,242.81,306.17,256.36Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.82,272.61c-7,4.43-4.93,9.26-3.24,17.65,3.82,18.91,8.94,55.45,7,64.65-2.28,10.76-8.69,17.62-17.5,17.62-4.09,0-5.05,3.93-9.48,2-9.48-4.07-16.62-1.1-20,1.69-13.89,11.52,3.66,52.2,24,62,18.2,8.73,37.71,3,47.32-.89,3.44-1.4,7.09-.74,10.69.18,18.88,4.77,34.12-11.48,35.81-26,2.6-22.36-4.4-23.37-7.92-48.09a60.19,60.19,0,0,1-.33-8.13c-.11-17.1,6.78-33,5.07-58.93-.68-10.23-2.29-23.35-9.14-27.09C317.4,253.55,284.05,272.47,283.82,272.61Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-3--inject-15)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M302.58,324.32l-4.41,26.48c-.59,3.55-1.25,7.26-3.46,10.09s-6.51,4.4-9.51,2.42c-.28-4,3.12-7.06,5.58-10.18,6.64-8.38,7.45-19.84,7.75-30.53.27-9.89-.38-28.65,10-34.16C307.52,300.37,304.55,312.49,302.58,324.32Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.38,365.52l.46.6c-.86,1.07-2.36,1.34-3.72,1.56s-2.87.53-3.69,1.63-.19,3.18,1.19,3.07c-1.76.14-14.81-.34-12.62-4.67C292.14,365.48,306.66,365.78,309.38,365.52Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283,388c.69.6,1.44,1.55.94,2.31s-1.69.46-2.49,0c-3.62-2.08-7-5.73-8.12-9.8C276.44,380.52,280.67,385.9,283,388Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.47,384.65a13.72,13.72,0,0,0,2,7.11l-3.84-5.12A50.79,50.79,0,0,0,288.33,409a16.74,16.74,0,0,1-7.75-9.92c.4,1.41,3.69-.2,3.14-2.08-.5-1.66-2.73-1.13-4.05-1.7C275.19,393.42,272.08,388.53,269.47,384.65Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M236.08,391.13c8.85,16.23,25.2,28.54,40.61,38.76C295,442,313,435.42,329.55,432c-3.56,2.14-2.69,3.91.9,4.63,5.63-.1,10.67-3.16,15.14-6.59s8.2-8.56,12.84-17.29c-2.14,14-18.9,28.34-33.33,25.31-5-1-9.18-1.52-12.46-.54-3.86,1.15-4.72,1.4-11.78,3.39-12.65,3.56-30.64,3.28-42.4-6.11a57.38,57.38,0,0,1-16.41-21.9,77.24,77.24,0,0,1-5.94-21.57Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M351.64,333.8c-.07,6.05-1.55,12-1.87,18.05.27-5.07-1.25-10.56-1.23-15.74,0-3.87-.74-11.91,1.65-15.05A43,43,0,0,1,351.64,333.8Z",
    style: {
      opacity: 0.2
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M283.82,272.61c-7,4.43-4.93,9.26-3.24,17.65,3.82,18.91,8.94,55.45,7,64.65-2.28,10.76-8.69,17.62-17.5,17.62-4.09,0-5.05,3.93-9.48,2-9.48-4.07-16.62-1.1-20,1.69-13.89,11.52,3.66,52.2,24,62,18.2,8.73,37.71,3,47.32-.89,3.44-1.4,7.09-.74,10.69.18,18.88,4.77,34.12-11.48,35.81-26,2.6-22.36-4.4-23.37-7.92-48.09a60.19,60.19,0,0,1-.33-8.13c-.11-17.1,6.78-33,5.07-58.93-.68-10.23-2.29-23.35-9.14-27.09C317.4,253.55,284.05,272.47,283.82,272.61Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.33,352.65s-7.07-4.53-8.94-4.35-4.35,1.6-5,1.66-2.39-.24-3.5.57a12,12,0,0,0-2.13,2.36,28.93,28.93,0,0,0-3.35,2.21c-1.76,1.35-5.69,7.17-6.28,8.42s.18,1.87,1.28,1.06c.81-.61,4.19-3.78,5.91-5.4a2.2,2.2,0,0,1,2.32-.45c1.89.74,5.27,2.13,6.36,3.06a12.8,12.8,0,0,0,6.71,3.1,37.43,37.43,0,0,0,7.1,0s3.84-4.86,2.77-8.07A6.7,6.7,0,0,0,248.33,352.65Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-4--inject-15)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M294.08,331.47c-2.6,6.93-6.67,13.48-12.61,17.89-4.44,3.29-9.71,5.25-15,7q-7.25,2.44-14.62,4.52c-1.57.44-3.4.83-4.73-.12a3.76,3.76,0,0,1-1.17-3.93,11,11,0,0,1,2.06-3.8,7.66,7.66,0,0,0-5.1,4.81c-.43,1.24-.6,2.71-1.66,3.51a2.88,2.88,0,0,1-4-1,4.68,4.68,0,0,1,0-4.41,13.82,13.82,0,0,1,2.82-3.6c-1.14-.35-2.22.68-2.82,1.71s-1.11,2.25-2.2,2.72c-1.34.57-2.82-.27-4.23-.61a8,8,0,0,0-7.15,2.25,18.46,18.46,0,0,0-4.13,6.56,8.92,8.92,0,0,1,14.3-3.23,16.26,16.26,0,0,0,3,2.7,8.17,8.17,0,0,0,3.86.65,132.62,132.62,0,0,0,38.66-5.8c5.33-1.64,10.88-3.84,14.13-8.38,2.54-3.53,3.32-8,3.88-12.31q.89-6.83,1.24-13.69c.22-4.12.8-8.78.12-12.85C297.37,318.62,296.45,325.16,294.08,331.47Z",
    style: {
      fill: "#92E3A9",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.08,331.47c-2.6,6.93-6.67,13.48-12.61,17.89-4.44,3.29-9.71,5.25-15,7q-7.25,2.44-14.62,4.52c-1.57.44-3.4.83-4.73-.12a3.76,3.76,0,0,1-1.17-3.93,11,11,0,0,1,2.06-3.8,7.66,7.66,0,0,0-5.1,4.81c-.43,1.24-.6,2.71-1.66,3.51a2.88,2.88,0,0,1-4-1,4.68,4.68,0,0,1,0-4.41,13.82,13.82,0,0,1,2.82-3.6c-1.14-.35-2.22.68-2.82,1.71s-1.11,2.25-2.2,2.72c-1.34.57-2.82-.27-4.23-.61a8,8,0,0,0-7.15,2.25,18.46,18.46,0,0,0-4.13,6.56,8.92,8.92,0,0,1,14.3-3.23,16.26,16.26,0,0,0,3,2.7,8.17,8.17,0,0,0,3.86.65,132.62,132.62,0,0,0,38.66-5.8c5.33-1.64,10.88-3.84,14.13-8.38,2.54-3.53,3.32-8,3.88-12.31q.89-6.83,1.24-13.69c.22-4.12.8-8.78.12-12.85C297.37,318.62,296.45,325.16,294.08,331.47Z",
    style: {
      fill: "#fff",
      opacity: 0.5,
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M248.33,352.65s-7.07-4.53-8.94-4.35-4.35,1.6-5,1.66-2.39-.24-3.5.57a12,12,0,0,0-2.13,2.36,28.93,28.93,0,0,0-3.35,2.21c-1.76,1.35-5.69,7.17-6.28,8.42s.18,1.87,1.28,1.06c.81-.61,4.19-3.78,5.91-5.4a2.2,2.2,0,0,1,2.32-.45c1.89.74,5.27,2.13,6.36,3.06a12.8,12.8,0,0,0,6.71,3.1,37.43,37.43,0,0,0,7.1,0s3.84-4.86,2.77-8.07A6.7,6.7,0,0,0,248.33,352.65Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299,292.71c-.45-6.81-6.75-20.07-13.48-21.2a31.59,31.59,0,0,0-4.41,2.94c-2.56,2.05-3.33,6.14-3.56,14.76s1.36,28.45.34,46.74c0,.34-25.51,14.11-29.93,16.25s-7.28,6.17-4.77,10.4c2.23,3.75,7,2.94,11.33,2.36,5.81-.77,33-6.45,37.94-11.51C302.24,343.29,299,292.71,299,292.71Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-5--inject-15)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M294.08,331.47c-2.6,6.93-6.67,13.48-12.61,17.89-4.44,3.29-9.71,5.25-15,7q-7.25,2.44-14.62,4.52c-1.57.44-3.4.83-4.73-.12a3.76,3.76,0,0,1-1.17-3.93,11,11,0,0,1,2.06-3.8,7.66,7.66,0,0,0-5.1,4.81c-.43,1.24-.6,2.71-1.66,3.51a2.88,2.88,0,0,1-4-1,4.68,4.68,0,0,1,0-4.41,13.82,13.82,0,0,1,2.82-3.6c-1.14-.35-2.22.68-2.82,1.71s-1.11,2.25-2.2,2.72c-1.34.57-2.82-.27-4.23-.61a8,8,0,0,0-7.15,2.25,18.46,18.46,0,0,0-4.13,6.56,8.92,8.92,0,0,1,14.3-3.23,16.26,16.26,0,0,0,3,2.7,8.17,8.17,0,0,0,3.86.65,132.62,132.62,0,0,0,38.66-5.8c5.33-1.64,10.88-3.84,14.13-8.38,2.54-3.53,3.32-8,3.88-12.31q.89-6.83,1.24-13.69c.22-4.12.8-8.78.12-12.85C297.37,318.62,296.45,325.16,294.08,331.47Z",
    style: {
      fill: "#92E3A9",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.08,331.47c-2.6,6.93-6.67,13.48-12.61,17.89-4.44,3.29-9.71,5.25-15,7q-7.25,2.44-14.62,4.52c-1.57.44-3.4.83-4.73-.12a3.76,3.76,0,0,1-1.17-3.93,11,11,0,0,1,2.06-3.8,7.66,7.66,0,0,0-5.1,4.81c-.43,1.24-.6,2.71-1.66,3.51a2.88,2.88,0,0,1-4-1,4.68,4.68,0,0,1,0-4.41,13.82,13.82,0,0,1,2.82-3.6c-1.14-.35-2.22.68-2.82,1.71s-1.11,2.25-2.2,2.72c-1.34.57-2.82-.27-4.23-.61a8,8,0,0,0-7.15,2.25,18.46,18.46,0,0,0-4.13,6.56,8.92,8.92,0,0,1,14.3-3.23,16.26,16.26,0,0,0,3,2.7,8.17,8.17,0,0,0,3.86.65,132.62,132.62,0,0,0,38.66-5.8c5.33-1.64,10.88-3.84,14.13-8.38,2.54-3.53,3.32-8,3.88-12.31q.89-6.83,1.24-13.69c.22-4.12.8-8.78.12-12.85C297.37,318.62,296.45,325.16,294.08,331.47Z",
    style: {
      fill: "#fff",
      opacity: 0.5,
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M299,292.71c-.45-6.81-6.75-20.07-13.48-21.2a31.59,31.59,0,0,0-4.41,2.94c-2.56,2.05-3.33,6.14-3.56,14.76s1.36,28.45.34,46.74c0,.34-25.51,14.11-29.93,16.25s-7.28,6.17-4.77,10.4c2.23,3.75,7,2.94,11.33,2.36,5.81-.77,33-6.45,37.94-11.51C302.24,343.29,299,292.71,299,292.71Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.17,233.54c4.29-8.37.5-19.24-5.08-26.82-9.18-12.49-28.66-16.19-43.31-14.21-6.86.93-13.74,4.26-17.3,10.2s-2.7,14.67,3,18.66c5.31,3.75,13.74,3.14,17,8.79,3.44,6-2.27,13.22-2.36,20.16-.07,4.37,2.15,8.52,2.17,12.9C302.21,263.22,336,257.37,348.17,233.54Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.83,351.36s.1,1-4-1.7c-3.9-2.54-14.06,6.78-10.15,13.14l.33,1.09c.44,1.48,3.28.52,4.74,1a11.37,11.37,0,0,0,5.59.5C249.4,365.07,240.94,360,249.83,351.36Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-6--inject-15)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M294.08,331.47c-2.6,6.93-6.67,13.48-12.61,17.89-4.44,3.29-9.71,5.25-15,7q-7.25,2.44-14.62,4.52c-1.57.44-3.4.83-4.73-.12a3.76,3.76,0,0,1-1.17-3.93,11,11,0,0,1,2.06-3.8,7.66,7.66,0,0,0-5.1,4.81c-.43,1.24-.6,2.71-1.66,3.51a2.88,2.88,0,0,1-4-1,4.68,4.68,0,0,1,0-4.41,13.82,13.82,0,0,1,2.82-3.6c-1.14-.35-2.22.68-2.82,1.71s-1.11,2.25-2.2,2.72c-1.34.57-2.82-.27-4.23-.61a8,8,0,0,0-7.15,2.25,18.46,18.46,0,0,0-4.13,6.56,8.92,8.92,0,0,1,14.3-3.23,16.26,16.26,0,0,0,3,2.7,8.17,8.17,0,0,0,3.86.65,132.62,132.62,0,0,0,38.66-5.8c5.33-1.64,10.88-3.84,14.13-8.38,2.54-3.53,3.32-8,3.88-12.31q.89-6.83,1.24-13.69c.22-4.12.8-8.78.12-12.85C297.37,318.62,296.45,325.16,294.08,331.47Z",
    style: {
      fill: "#92E3A9",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.08,331.47c-2.6,6.93-6.67,13.48-12.61,17.89-4.44,3.29-9.71,5.25-15,7q-7.25,2.44-14.62,4.52c-1.57.44-3.4.83-4.73-.12a3.76,3.76,0,0,1-1.17-3.93,11,11,0,0,1,2.06-3.8,7.66,7.66,0,0,0-5.1,4.81c-.43,1.24-.6,2.71-1.66,3.51a2.88,2.88,0,0,1-4-1,4.68,4.68,0,0,1,0-4.41,13.82,13.82,0,0,1,2.82-3.6c-1.14-.35-2.22.68-2.82,1.71s-1.11,2.25-2.2,2.72c-1.34.57-2.82-.27-4.23-.61a8,8,0,0,0-7.15,2.25,18.46,18.46,0,0,0-4.13,6.56,8.92,8.92,0,0,1,14.3-3.23,16.26,16.26,0,0,0,3,2.7,8.17,8.17,0,0,0,3.86.65,132.62,132.62,0,0,0,38.66-5.8c5.33-1.64,10.88-3.84,14.13-8.38,2.54-3.53,3.32-8,3.88-12.31q.89-6.83,1.24-13.69c.22-4.12.8-8.78.12-12.85C297.37,318.62,296.45,325.16,294.08,331.47Z",
    style: {
      fill: "#fff",
      opacity: 0.5,
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M249.83,351.36s.1,1-4-1.7c-3.9-2.54-14.06,6.78-10.15,13.14l.33,1.09c.44,1.48,3.28.52,4.74,1a11.37,11.37,0,0,0,5.59.5C249.4,365.07,240.94,360,249.83,351.36Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.93,197.46c-2.93,3.62-2.71,8.94-1.06,13.29s4.49,8.15,6.56,12.32,4.63,8.47,2.9,12.8a60.81,60.81,0,0,0,.89-28.6",
    style: {
      fill: "none",
      stroke: "#757575",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.9,194.53c15.3,14.73,19.91,29.07,20.6,42.29",
    style: {
      fill: "none",
      stroke: "#757575",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.15,201.84a57.16,57.16,0,0,1,3.37,29.51",
    style: {
      fill: "none",
      stroke: "#757575",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.73,200.71a13.23,13.23,0,0,0-4.06,7.83",
    style: {
      fill: "none",
      stroke: "#757575",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.57,199.53a14,14,0,0,0-.3,10.92",
    style: {
      fill: "none",
      stroke: "#757575",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.5,199.14a28.59,28.59,0,0,1,13.86,22.23",
    style: {
      fill: "none",
      stroke: "#757575",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.58,201.75a13.22,13.22,0,0,1,4.34,4.7",
    style: {
      fill: "none",
      stroke: "#757575",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.32,379.91a43.76,43.76,0,0,0,21,29.07",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.05,376.26a15.77,15.77,0,0,0,11.25,14.45",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.47,365.2l-17.1,2.23c-.85.11-1.84.32-2.19,1.11a1.72,1.72,0,0,0,.62,1.94,4.84,4.84,0,0,0,2,.81,116,116,0,0,0,22.64,2.94",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.13,438.46a61.61,61.61,0,0,1,17.25-5.21",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.82,352a7.76,7.76,0,0,0-3.22,2.11c-.91.93-1.68,2-2.55,2.95a1.51,1.51,0,0,1-.53.44.56.56,0,0,1-.64-.11.81.81,0,0,1,0-.76,7.89,7.89,0,0,1,2.18-3.24",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.91,290.89l-5.52,19.28",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.35,318.75c-2.33,17.74-.8,39.25,2.35,55.81",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.18,312.36l-.35,2.86",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadBro);
export default __webpack_public_path__ + "static/media/Download-bro.46953be36334655c0a9bacd99f09f643.svg";
export { ForwardRef as ReactComponent };